/* Theme - product page behaviour
   - keeps the ON SALE flag in sync with the selected variant
   - prints the running total on the Add to cart button
   - toggled add-ons and shipping protection are added on the same click
*/
(function () {
  'use strict';

  var CFG = window.DzPDP || {};
  var CURRENCY = CFG.currency || 'USD';
  var LOCALE = CFG.locale || 'en-US';

  function money(cents) {
    var amount = (cents || 0) / 100;
    try {
      return new Intl.NumberFormat(LOCALE, {
        style: 'currency',
        currency: CURRENCY
      }).format(amount);
    } catch (e) {
      return '$' + amount.toFixed(2);
    }
  }

  function parseMoneyToCents(text) {
    if (!text) return null;
    var cleaned = text.replace(/[^\d.,]/g, '').replace(/,/g, '');
    var value = parseFloat(cleaned);
    return isNaN(value) ? null : Math.round(value * 100);
  }

  /* ---------------------------------------------------------
     One controller per product-info block on the page
     --------------------------------------------------------- */
  function Controller(scope) {
    this.scope = scope;
    this.button = scope.querySelector('.product-form__submit');
    this.flag = scope.querySelector('[data-dz-flag]');
    this.busy = false;
    this._base = null;
    this.baseLabel();
    this.bind();
    this.sync();
    var self = this;
    window.setTimeout(function () {
      self.sync();
    }, 500);
  }

  /* "Add to cart", captured before any animation can overwrite it */
  Controller.prototype.baseLabel = function () {
    if (this._base) return this._base;
    var span = this.button && this.button.querySelector('span:not(.visually-hidden)');
    var fromDom = span ? span.textContent.split(' - ')[0].trim() : '';
    var strings = window.variantStrings || {};
    this._base = fromDom || strings.addToCart || 'Add to cart';
    return this._base;
  };

  Controller.prototype.qty = function () {
    var input = this.scope.querySelector('.quantity__input');
    var value = input ? parseInt(input.value, 10) : 1;
    return isNaN(value) || value < 1 ? 1 : value;
  };

  Controller.prototype.variantCents = function () {
    var node = this.scope.querySelector('script[data-selected-variant]');
    if (node) {
      try {
        var variant = JSON.parse(node.textContent);
        if (variant && typeof variant.price === 'number') return variant.price;
      } catch (e) {
        /* fall through to the rendered price */
      }
    }
    var priceEl =
      this.scope.querySelector('.price--on-sale .price-item--sale') ||
      this.scope.querySelector('.price .price-item--regular');
    return parseMoneyToCents(priceEl && priceEl.textContent);
  };

  /* every toggle in the buy box: add-on rows and shipping protection */
  Controller.prototype.addons = function () {
    var rows = this.scope.querySelectorAll('.dz-addon__checkbox');
    return Array.prototype.filter.call(rows, function (input) {
      return input.checked && !input.disabled && input.dataset.variantId;
    });
  };

  Controller.prototype.isOnSale = function () {
    return !!this.scope.querySelector('.price--on-sale');
  };

  /* Total shown on the button: variant x quantity + every toggled extra */
  Controller.prototype.total = function () {
    var base = this.variantCents();
    if (base === null) return null;
    var total = base * this.qty();
    this.addons().forEach(function (input) {
      total += parseInt(input.dataset.price, 10) || 0;
    });
    return total;
  };

  Controller.prototype.syncFlag = function () {
    if (!this.flag) return;
    if (this.flag.dataset.alwaysShow === 'true') return;
    this.flag.hidden = !this.isOnSale();
  };

  Controller.prototype.syncButton = function () {
    var button = this.button;
    if (!button) return;
    // leave the button alone while the add-to-cart animation owns it
    if (button.classList.contains('dz-atc-success') || button.classList.contains('loading')) return;
    if (button.disabled || button.getAttribute('aria-disabled') === 'true') return;

    var span = button.querySelector('span:not(.visually-hidden)');
    if (!span) return;

    var total = CFG.priceInButton === false ? null : this.total();
    var label = total === null ? this.baseLabel() : this.baseLabel() + ' - ' + money(total);
    if (span.textContent.trim() !== label) span.textContent = label;
  };

  /* the sticky mobile bar reads the struck compare-at price on sale items -
     keep it showing what the customer will actually pay */
  Controller.prototype.syncStickyBar = function () {
    var target = document.querySelector('#dz-sticky-atc .dz-sticky-atc__price');
    if (!target) return;
    var cents = this.variantCents();
    if (cents === null) return;
    var text = money(cents);
    if (target.textContent !== text) target.textContent = text;
  };

  Controller.prototype.sync = function () {
    this.syncFlag();
    this.syncButton();
    this.syncStickyBar();
  };

  Controller.prototype.bind = function () {
    var self = this;

    this.scope.addEventListener('change', function (event) {
      if (event.target.closest('.quantity') || event.target.classList.contains('dz-addon__checkbox')) {
        self.syncButton();
      }
    });

    this.scope.addEventListener('input', function (event) {
      if (event.target.classList.contains('quantity__input')) self.syncButton();
    });

    // Dawn swaps the price / button markup on variant change - re-sync once it settles.
    var pending = null;
    var observer = new MutationObserver(function () {
      if (pending) return;
      pending = window.requestAnimationFrame(function () {
        pending = null;
        self.button = self.scope.querySelector('.product-form__submit');
        self.flag = self.scope.querySelector('[data-dz-flag]');
        self.sync();
      });
    });
    observer.observe(this.scope, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['disabled', 'aria-disabled', 'class']
    });
  };

  /* ---------------------------------------------------------
     Add to cart with extras.
     The extras go in first with a silent request, then the form is
     submitted again and Dawn's own product-form handles the product,
     the cart notification and the cart bubble exactly as it normally does.
     --------------------------------------------------------- */
  function showError(form, message) {
    var wrapper = form.closest('product-form');
    var box = wrapper && wrapper.querySelector('.product-form__error-message-wrapper');
    var text = wrapper && wrapper.querySelector('.product-form__error-message');
    if (!box || !text) return;
    text.textContent = message;
    box.hidden = false;
  }

  function resubmit(form) {
    form.dataset.dzPassthrough = '1';
    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit();
    } else {
      form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    }
  }

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || form.dataset.type !== 'add-to-cart-form') return;

      // second pass: let Dawn handle it
      if (form.dataset.dzPassthrough === '1') {
        delete form.dataset.dzPassthrough;
        return;
      }

      var scope = form.closest('product-info');
      if (!scope) return;

      var controller = scope.dzController;
      if (!controller) return;

      var chosen = controller.addons();
      if (!chosen.length) return; // nothing toggled - normal Dawn path

      event.preventDefault();
      event.stopPropagation();

      if (controller.busy) return;
      controller.busy = true;

      var items = chosen.map(function (input) {
        return { id: parseInt(input.dataset.variantId, 10), quantity: 1 };
      });

      var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';

      fetch(addUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (response) {
          return response.json();
        })
        .then(
          function (data) {
            controller.busy = false;
            if (data && data.status) {
              showError(form, data.description || data.message || 'That extra could not be added.');
              return;
            }
            chosen.forEach(function (input) {
              input.checked = false;
            });
            controller.syncButton();
            resubmit(form);
          },
          function () {
            controller.busy = false;
            showError(form, 'Something went wrong. Please try again.');
          }
        );
    },
    true
  );

  /* --------------------------------------------------------- */
  function init() {
    if (document.querySelector('.dz-trust')) {
      document.body.classList.add('dz-has-trust-card');
    }
    document.querySelectorAll('product-info').forEach(function (scope) {
      if (scope.dzController) return;
      if (!scope.querySelector('.dz-pdp')) return;
      scope.dzController = new Controller(scope);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
